import React, { useCallback, useEffect, useMemo } from 'react'

import { useHistory } from 'react-router-dom'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { DeliveryActions } from 'Redux/delivery'
import { providerDatesAlerts as providerDatesAlertsSelector } from 'Redux/delivery/utils'
import { setProviders } from 'Redux/purchases/actions'
import ProviderDateAlert from 'Components/molecules/provider-date-alert'
import routes from 'Config/routes'

import { AlertContainer } from './styled'

const ProviderDateAlerts = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const providerDatesAlerts = useSelector(providerDatesAlertsSelector)

  useEffect(() => {
    dispatch(DeliveryActions.fetchProviderDatesAlerts())
  }, [dispatch])

  const handleAlert = useCallback(
    alert => {
      dispatch(
        setProviders([
          {
            name: alert.provider.name,
            id: alert.provider.id,
            nextDeliveryDate: alert.nextDeliveryDate,
            calendar: alert.calendar,
          },
        ])
      )
      history.push(`${routes.addProvider(alert.provider.id)}/category/all`)
    },
    [dispatch, history]
  )

  const filteredAlerts = useMemo(() => {
    const today = moment().startOf('day')
    const dayOfWeek = today.day()
    return providerDatesAlerts.filter(element => {
      if (!element.limitDate) return false

      const limitDate = moment(element.limitDate)
      const limitDateDay = limitDate.clone().startOf('day')
      const daysUntilLimit = limitDateDay.diff(today, 'days')

      if (dayOfWeek === 5) {
        if (daysUntilLimit < 2 || daysUntilLimit > 3) return false
      } else if (daysUntilLimit < 0 || daysUntilLimit > 1) return false

      if (limitDate.isSame(today, 'day')) {
        const deliveryHour = moment(element.deliveryDate).hour()
        const limitHour = limitDate.hour()
        return deliveryHour <= limitHour
      }

      return true
    })
  }, [providerDatesAlerts])

  return (
    <AlertContainer>
      {filteredAlerts.map((element, index) => (
        <ProviderDateAlert
          key={index}
          providerName={element.provider?.name || ''}
          date={moment(element.deliveryDate).format('DD/MM/YYYY')}
          onAction={() => handleAlert(element)}
        />
      ))}
    </AlertContainer>
  )
}

export default ProviderDateAlerts
